export const PAGE_TITLE = 'Second Step'
